import { render, staticRenderFns } from "./ResultadoFinal.vue?vue&type=template&id=3ca71636&scoped=true"
import script from "./ResultadoFinal.vue?vue&type=script&lang=js"
export * from "./ResultadoFinal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca71636",
  null
  
)

export default component.exports